import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    selectedCategoryId: '00',
    selectedStoreId: '00000',

    actualSummary: {},
    planSummary: {},
    startDate: '',
    endDate: ''
  },

  getters: {
    selectedCategoryId(state) {
      return state.selectedCategoryId
    },
    selectedStoreId(state) {
      return state.selectedStoreId
    },
    actualSummary(state) {
      return state.actualSummary
    },
    planSummary(state) {
      return state.planSummary
    },
    startDate(state) {
      return state.startDate
    },
    endDate(state) {
      return state.endDate
    }
  },

  mutations: {
    summary(state, payload) {
      state.actualSummary = payload.actual
      state.planSummary = payload.plan
      state.startDate = payload.start_date
      state.endDate = payload.end_date
    },
    resetSummary(state) {
      state.actualSummary = {}
      state.planSummary = {}
      state.startDate = ''
      state.endDate = ''
    },

    categoryId(state, payload) {
      state.selectedCategoryId = payload
    },
    storeId(state, payload) {
      state.selectedStoreId = payload
    }
  },

  actions: {
    /**
     * サマリデータ取得
     */
    getSummary({ commit }, payload) {
      api.get('/api/v2/summary/get', {})
        .then((res) => {
          commit('summary', res.data)
        })
    },

    /**
     * サマリデータの対象となるカテゴリを設定
     */
    setCategoryId({ commit }, payload) {
      commit('categoryId', payload)
    },

    /**
     * サマリデータの対象となる店舗を設定
     */
    setStoreId({ commit }, payload) {
      commit('storeId', payload)
    },

    /**
     * ログアウト時にサマリデータをリセットする
     */
    resetSummary({ commit }) {
      commit('resetSummary')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/summary.js